import { memo } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { FormFieldProps } from "./types";
import { Separator } from "@/components/ui/separator";

interface RadioOption {
  label: string;
  value: string;
}

const RadioGroupField = memo(({ config, control }: FormFieldProps) => {
  return (
    <div className={config.className}>
      <FormField
        control={control}
        name={config.name}
        render={({ field }) => (
          <FormItem className="space-y-3">
            {config.label && (
              <FormLabel className="text-slate-700 text-sm font-medium font-['Raleway'] leading-normal">
                {config.label}
              </FormLabel>
            )}
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                className="flex items-center flex-wrap"
              >
                {config.radioChoices?.map((option: RadioOption) => (
                  <div key={option.value} className="flex items-center">
                    <RadioGroupItem value={option.value} id={option.value} />
                    <Label
                      htmlFor={option.value}
                      className="text-slate-700 ml-1 text-sm font-medium font-['Raleway'] leading-normal"
                    >
                      {option.label}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
          </FormItem>
        )}
      />
      {config.separator && <Separator className="my-4" />}
    </div>
  );
});

RadioGroupField.displayName = "RadioGroupField";
export default RadioGroupField;
